/**
 * Tactical Hex Grid
 *
 * Home page background overlay: a faint repeating hex grid pattern
 * that slowly shifts, evoking a strategy map / war table surface.
 */

import React from 'react';

export const HexGrid: React.FC = () => {
  return <div className="hex-grid-layer" />;
};
